import Vue from 'vue';
import Router from 'vue-router';

import start from './wizardElements/start.vue';
import danovePriznanie from './wizardElements/danovePriznanie.vue';
import udajeDanovnikovi from './wizardElements/dpfoU.vue';
import prijmyVydavky from './wizardElements/prijmyVydavky.vue';
import download from './wizardElements/download.vue';

import danovnik from './udajeDanovnikovi/danovnik.vue';
import predlzenie from './udajeDanovnikovi/predlzenie.vue';
import manzel from './udajeDanovnikovi/manzel.vue';
import osobitneZaznamy from './udajeDanovnikovi/osobitneZaznamy.vue';
import poukazanie from './udajeDanovnikovi/poukazanie.vue';
import vyzDeti from './udajeDanovnikovi/vyzDeti.vue';
import zaplatenePrispevky from './udajeDanovnikovi/zaplatenePrispevky.vue';
import zakonnyZastupca from './udajeDanovnikovi/zakonnyZastupca.vue';

// -----------------Prijmy/Vydavky-----------------------

import tuzemskePar5 from './prijmyVydavky/zavislaCinnost/tuzemske.vue';
import zahranicnePar5 from './prijmyVydavky/zavislaCinnost/zahranicne.vue';

import sposobUct6o12 from './prijmyVydavky/podnikSZC/sposobUct.vue';
import tuzPrijmy6o12 from './prijmyVydavky/podnikSZC/tuzPrijmy6.vue';
import zahranicnePrijmy6 from './prijmyVydavky/podnikSZC/zahranicnePrijmy6.vue';

import sposobUctovania6o3 from './prijmyVydavky/prenajom6ods3/sposobUctovania.vue';
import oslobednePrijmy from './prijmyVydavky/prenajom6ods3/oslobednePrijmy.vue';
import tuzemskePrijmy6o3 from './prijmyVydavky/prenajom6ods3/tuzemskePrijmy6o3.vue';
import zahranicnePrijmy6o3 from './prijmyVydavky/prenajom6ods3/zahranicnePrijmy6o3.vue';

import sposobUctovania6o4 from './prijmyVydavky/licence6ods4/sposobuctovania6ods4.vue';
import tuzemskePrijmy6o4 from './prijmyVydavky/licence6ods4/tuzemskePrijmy6ods4.vue';
import zahranicnePrijmy6o4 from './prijmyVydavky/licence6ods4/zahranicnePrijmy6ods4.vue';

import tuzemskePrijmy7 from './prijmyVydavky/kapitalovePrijmy7/tuzemskePrijmy7.vue';
import zahranicnePrijmy7 from './prijmyVydavky/kapitalovePrijmy7/zahranicnePrijmy7.vue';
import urokovePrijmy7 from './prijmyVydavky/kapitalovePrijmy7/urokovePrijmy.vue';

import tuzemskePrijmy8 from './prijmyVydavky/ostatne8/tuzemskePrijmy8.vue';
import zahranicnePrijmy8 from './prijmyVydavky/ostatne8/zahranicnePrijmy8.vue';

import tabulkaOMajetku from './prijmyVydavky/tabulkaOMajetku.vue';
import poistneOdvody from './prijmyVydavky/poistneOdvody.vue';
import preddavky from './prijmyVydavky/preddavky.vue';
import odpocetDanovejStraty from './prijmyVydavky/odpocetDanovejStraty.vue';
import sposobZahrnovania from './prijmyVydavky/sposobZahrnovania.vue';
import rekreacia from './prijmyVydavky/rekreacia.vue'

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '/',
      name: 'start',
      components: {
        a: start,
      },
    },
    {
      path: '/danovePriznanie',
      name: 'danovePriznanie',
      components: {
        a: danovePriznanie,
      },
    },
    {
      path: '/udajeDanovnikovi/:userId',
      name: 'udajeDanovnikovi',
      components: {
        a: udajeDanovnikovi,
      },
      children: [
        {
          path: 'danovnik',
          name: 'danovnik',
          components: {
            b: danovnik,
          },
        },
        {
          path: 'predlzenie',
          name: 'predlzenie',
          components: {
            b: predlzenie,
          },
        },

        {
          path: 'zd/zaplatenePrispevky',
          name: 'zaplatenePrispevky',
          components: {
            b: zaplatenePrispevky,
          },
        },
        {
          path: 'zd/manzel',
          name: 'manzel',
          components: {
            b: manzel,
          },
        },
        {
          path: 'zd/vyzDeti',
          name: 'vyzDeti',
          components: {
            b: vyzDeti,
          },
        },

        {
          path: 'osobitneZaznamy',
          name: 'osobitneZaznamy',
          components: {
            b: osobitneZaznamy,
          },
        },
        {
          path: 'poukazanie',
          name: 'poukazanie',
          components: {
            b: poukazanie,
          },
        },
        {
          path: 'zakonnyZastupca',
          name: 'zakonnyZastupca',
          components: {
            b: zakonnyZastupca,
          },
        },
      ],
    },
    {
      path: '/prijmyVydavky/:userId',
      name: 'prijmyVydavky',
      components: {
        a: prijmyVydavky,
      },
      children: [
        {
          path: 'par5/tuzemske',
          name: 'tuzemskePar5',
          components: {
            pv: tuzemskePar5,
          },
        },
        {
          path: 'par5/zahranicne',
          name: 'zahranicnePar5',
          components: {
            pv: zahranicnePar5,
          },
        },
        // -----------PAR6-------------------------
        {
          path: 'par6ods1/sposobUct',
          name: 'sposobUct6o12',
          components: {
            pv: sposobUct6o12,
          },
        },
        {
          path: 'par6ods1/tuzemske',
          name: 'tuzPrijmy6o12',
          components: {
            pv: tuzPrijmy6o12,
          },
        },
        {
          path: 'par6ods1/zahranicne',
          name: 'zahranicnePrijmy6',
          components: {
            pv: zahranicnePrijmy6,
          },
        },
        //---------------------------------------------
        {
          path: 'par6ods3/sposobUct',
          name: 'sposobUctovania6o3',
          components: {
            pv: sposobUctovania6o3,
          },
        },
        {
          path: 'par6ods3/oslobedne',
          name: 'oslobednePrijmy',
          components: {
            pv: oslobednePrijmy,
          },
        },
        {
          path: 'par6ods3/tuzemske',
          name: 'tuzemskePrijmy6o3',
          components: {
            pv: tuzemskePrijmy6o3,
          },
        },
        {
          path: 'par6ods3/zahranicne',
          name: 'zahranicnePrijmy6o3',
          components: {
            pv: zahranicnePrijmy6o3,
          },
        },
        //------------------------------------------
        {
          path: 'par6ods4/sposobUct',
          name: 'sposobUctovania6o4',
          components: {
            pv: sposobUctovania6o4,
          },
        },
        {
          path: 'par6ods4/tuzemske',
          name: 'tuzemskePrijmy6o4',
          components: {
            pv: tuzemskePrijmy6o4,
          },
        },
        {
          path: 'par6ods4/zahranicne',
          name: 'zahranicnePrijmy6o4',
          components: {
            pv: zahranicnePrijmy6o4,
          },
        },
        // -----------PAR7----------------------
        {
          path: 'par7/tuzemske',
          name: 'tuzemskePrijmy7',
          components: {
            pv: tuzemskePrijmy7,
          },
        },
        {
          path: 'par7/zahranicne',
          name: 'zahranicnePrijmy7',
          components: {
            pv: zahranicnePrijmy7,
          },
        },
        {
          path: 'par7/urokove',
          name: 'urokovePrijmy7',
          components: {
            pv: urokovePrijmy7,
          },
        },
        // -----------PAR8---------------------
        {
          path: 'par8/tuzemske',
          name: 'tuzemskePrijmy8',
          components: {
            pv: tuzemskePrijmy8,
          },
        },
        {
          path: 'par8/zahranicne',
          name: 'zahranicnePrijmy8',
          components: {
            pv: zahranicnePrijmy8,
          },
        },
        // ------------DOWN-----------------
        {
          path: 'tabulkaOMajetku',
          name: 'tabulkaOMajetku',
          components: {
            pv: tabulkaOMajetku,
          },
        },
        {
          path: 'poistneOdvody',
          name: 'poistneOdvody',
          components: {
            pv: poistneOdvody,
          },
        },
        {
          path: 'preddavky',
          name: 'preddavky',
          components: {
            pv: preddavky,
          },
        },
        {
          path: 'odpocetDanovejStraty',
          name: 'odpocetDanovejStraty',
          components: {
            pv: odpocetDanovejStraty,
          },
        },
        {
          path: 'sposobZahrnovania',
          name: 'sposobZahrnovania',
          components: {
            pv: sposobZahrnovania,
          },
        },
        {
          path: 'rekreacia',
          name: 'rekreacia',
          components: {
            pv: rekreacia,
          },
        }
      ],
    },

    {
      path: '/:userId/download',
      name: 'download',
      components: {
        a: download,
      },
    },
  ],
});
